import * as v from 'valibot';
// =============================================================================
// Common Schemas
// =============================================================================
/** Username: 3-32 chars, starts with letter, allows dots/hyphens/underscores */
export const UsernameSchema = v.pipe(v.string(), v.minLength(3, 'must be at least 3 characters'), v.maxLength(32, 'must be at most 32 characters'), v.regex(/^[a-z][a-z0-9._-]*$/, 'must start with a letter and contain only lowercase letters, numbers, dots, hyphens, or underscores'), v.regex(/^(?!.*[._-]{2}).*$/, 'cannot contain consecutive special characters'), v.regex(/.*[^._-]$/, 'cannot end with a special character'));
/** Base64 string (standard or URL-safe) */
export const Base64Schema = v.pipe(v.string(), v.minLength(1, 'cannot be empty'), v.regex(/^[A-Za-z0-9+/=_-]+$/, 'must be valid base64'));
/** Salt: Base64, minimum 16 chars */
export const SaltSchema = v.pipe(Base64Schema, v.minLength(16, 'salt must be at least 16 characters'));
/** Key hash: Base64, minimum 32 chars */
export const KeyHashSchema = v.pipe(Base64Schema, v.minLength(32, 'key hash must be at least 32 characters'));
/**
 * Generic Success for operations that return { success: true }
 */
export const SuccessResponseSchema = v.object({
    success: v.literal(true),
});
/**
 * Timestamp: ISO string or numeric ms
 * Backend is transitioning to stable numeric timestamps for consistency with D1/DO
 */
export const TimestampSchema = v.union([v.string(), v.number()]);
//# sourceMappingURL=common.js.map